import React, { useState, useContext, useEffect } from "react";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Form from 'react-bootstrap/Form';
import '../../assets/css/Booking.css';
import 'react-notifications/lib/notifications.css';
import { SignUp, getuser, getstafflistbyzone } from "../../Api/frontbooingApi";
import { BookingContext } from "./BookingContext";
import { LoginContext } from "../../LoginContext";
import { TbListCheck } from "react-icons/tb";

import { notify } from "../../../utils/notify";

const Step3 = props => {

    const [usertype, setUsertype, chooseservice, setChooseservice, choosesubservice, setChoosesubservice, chooseaddon, setChooseaddon, choosetechnician, setChoosetechnician, choosedate, setChoosedate, choosetime, setChoosetime, userDetails, setUserDetails, paymentDetails, setPaymentDetails, Totalpayment, setTotalpayment, totalDuration, setTotalDuration, appointmentNotes, setAppointmentNotes, servicename, setServicename, endchoosetime, setEndchoosetime, confirmpassword, setConfirmpassword, signUprequest, setSignUprequest, technicianList, setTechnicianList, expectedprice, setExpectedprice, expectedduration, setExpectedduration, availableTimestatus, setAvailableTimestatus, resetChoosetechnician, zipcode, setZipcode, bookingdata, setBookingData] = useContext(BookingContext);
    const { LoggedInData, login, logout } = useContext(LoginContext);

    const [existingemail, setExistingemail] = useState("")
    const [existingpassword, setExistingpassword] = useState("")
    const [buttonState, setButtonState] = useState(0)

    if (LoggedInData != null && buttonState == 0) {
        setUserDetails(LoggedInData);
        setButtonState(1);
    }

    const getUserDetails = () => {
        const formData = new FormData();
        formData.append("email", existingemail);
        formData.append("password", existingpassword);
        getuser(formData).then((res) => {
            if (res.code === 200) {
                if (res.data.status == '1') {
                    const apiResponse = res.data;
                    setUserDetails(apiResponse.data);
                    login(apiResponse.data);
                    setButtonState(1);
                }
                else {
                    NotificationManager.error('Invalid email and password', 'Close after 3000ms', 3000);
                }

            } else {
                notify.error("Something went wrong");
            }
        });
    };

    const states = [
        { name: "Alabama", cities: ["Birmingham", "Montgomery", "Mobile"], stateCode: "AL" },
        { name: "Alaska", cities: ["Anchorage", "Fairbanks", "Juneau"], stateCode: "AK" },
        { name: "Arizona", cities: ["Phoenix", "Tucson", "Mesa"], stateCode: "AZ" },
        { name: "Arkansas", cities: ["Little Rock", "Fort Smith", "Fayetteville"], stateCode: "AR" },
        { name: "California", cities: ["Los Angeles", "San Diego", "San Jose"], stateCode: "CA" },
        { name: "Colorado", cities: ["Denver", "Colorado Springs", "Aurora"], stateCode: "CO" },
        { name: "Connecticut", cities: ["Bridgeport", "New Haven", "Hartford"], stateCode: "CT" },
        { name: "Delaware", cities: ["Wilmington", "Dover", "Newark"], stateCode: "DE" },
        { name: "Florida", cities: ["Jacksonville", "Miami", "Tampa"], stateCode: "FL" },
        { name: "Georgia", cities: ["Atlanta", "Augusta", "Columbus"], stateCode: "GA" },
        { name: "Hawaii", cities: ["Honolulu", "Pearl City", "Hilo"], stateCode: "HI" },
        { name: "Idaho", cities: ["Boise", "Nampa", "Meridian"], stateCode: "ID" },
        { name: "Illinois", cities: ["Chicago", "Aurora", "Rockford"], stateCode: "IL" },
        { name: "Indiana", cities: ["Indianapolis", "Fort Wayne", "Evansville"], stateCode: "IN" },
        { name: "Iowa", cities: ["Des Moines", "Cedar Rapids", "Davenport"], stateCode: "IA" },
        { name: "Kansas", cities: ["Wichita", "Overland Park", "Kansas City"], stateCode: "KS" },
        { name: "Kentucky", cities: ["Louisville", "Lexington", "Bowling Green"], stateCode: "KY" },
        { name: "Louisiana", cities: ["New Orleans", "Baton Rouge", "Shreveport"], stateCode: "LA" },
        { name: "Maine", cities: ["Portland", "Lewiston", "Bangor"], stateCode: "ME" },
        { name: "Maryland", cities: ["Baltimore", "Frederick", "Rockville"], stateCode: "MD" },
        { name: "Massachusetts", cities: ["Boston", "Worcester", "Springfield"], stateCode: "MA" },
        { name: "Michigan", cities: ["Detroit", "Grand Rapids", "Warren"], stateCode: "MI" },
        { name: "Minnesota", cities: ["Minneapolis", "Saint Paul", "Rochester"], stateCode: "MN" },
        { name: "Mississippi", cities: ["Jackson", "Gulfport", "Southaven"], stateCode: "MS" },
        { name: "Missouri", cities: ["Kansas City", "Saint Louis", "Springfield"], stateCode: "MO" },
        { name: "Montana", cities: ["Billings", "Missoula", "Great Falls"], stateCode: "MT" },
        { name: "Nebraska", cities: ["Omaha", "Lincoln", "Bellevue"], stateCode: "NE" },
        { name: "Nevada", cities: ["Las Vegas", "Henderson", "Reno"], stateCode: "NV" },
        { name: "New Hampshire", cities: ["Manchester", "Nashua", "Concord"], stateCode: "NH" },
        { name: "New Jersey", cities: ["Newark", "Jersey City", "Paterson"], stateCode: "NJ" },
        { name: "New Mexico", cities: ["Albuquerque", "Las Cruces", "Rio Rancho"], stateCode: "NM" },
        { name: "New York", cities: ["New York", "Buffalo", "Rochester"], stateCode: "NY" },
        { name: "North Carolina", cities: ["Charlotte", "Raleigh", "Greensboro"], stateCode: "NC" },
        { name: "North Dakota", cities: ["Fargo", "Bismarck", "Grand Forks"], stateCode: "ND" },
        { name: "Ohio", cities: ["Columbus", "Cleveland", "Cincinnati"], stateCode: "OH" },
        { name: "Oklahoma", cities: ["Oklahoma City", "Tulsa", "Norman"], stateCode: "OK" },
        { name: "Oregon", cities: ["Portland", "Salem", "Eugene"], stateCode: "OR" },
    ];

    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');

    const handleStateChange = (event) => {
        setSelectedState(event.target.value);
        setUserDetails({ ...userDetails, state: event.target.value });
    };

    const handleCityChange = (event) => {
        setSelectedCity(event.target.value);
        setUserDetails({ ...userDetails, city: event.target.value });
    };

    // const cities = selectedState ? states.find((state) => state.name === selectedState).cities : [];

    const [validated, setValidated] = useState(false);

    useEffect(() => {
        if (signUprequest != 0) {
            // formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            // console.log("userDetails.user_email", userDetails.user_email);
            // console.log("userDetails", userDetails);
        }

    }, [signUprequest]);

    useEffect(() => {
        // if (bookingdata) {
        //     // : testing remove : and space from string
        //     const appointmentNotes = bookingdata.notes;
        //     setAppointmentNotes(bookingdata.notes);
        // }
        if (bookingdata !== null) {
            const appointmentNotes = bookingdata?.notes?.replace(/[:]/g, "");
            setAppointmentNotes(appointmentNotes);
        }
    }, [bookingdata]);

    const [error, setError] = useState(false);

    const getstaffbyzipcodenew = () => {

        getstafflistbyzone(userDetails.zip).then((res) => {
            if (res.code === 200) {
                if (res.data.status === "1") {
                    const apiResponse = res.data;
                    setError(false);
                } else {
                    setError(true);
                }
            } else {
                notify.error("Something went wrong");
            }
        });
    }

    useEffect(() => {
        getstaffbyzipcodenew();
    }, [userDetails.zip])

    // Method 3: Comprehensive Email Validation
    const validateEmailComprehensive = (email) => {
        // Check for basic format
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

        if (!emailRegex.test(email)) {
            return { valid: false, message: "Invalid email format" };
        }

        // Additional checks
        if (email.length > 254) {
            return { valid: false, message: "Email too long" };
        }

        const [localPart, domainPart] = email.split('@');

        if (localPart.length > 64) {
            return { valid: false, message: "Email local part too long" };
        }

        // Check for consecutive dots
        if (email.includes('..')) {
            return { valid: false, message: "Consecutive dots not allowed" };
        }

        // Check if starts or ends with dot
        if (localPart.startsWith('.') || localPart.endsWith('.')) {
            return { valid: false, message: "Email cannot start or end with a dot" };
        }

        // Check for valid TLD (Top Level Domain)
        const tldRegex = /\.[a-zA-Z]{2,}$/;
        if (!tldRegex.test(domainPart)) {
            return { valid: false, message: "Domain must have a valid top-level domain (like .com, .org, .in)" };
        }

        // Check if domain has at least one dot (to ensure it has a TLD)
        if (!domainPart.includes('.')) {
            return { valid: false, message: "Domain must include a top-level domain" };
        }

        // Ensure TLD is at least 2 characters and contains only letters
        const domainParts = domainPart.split('.');
        const tld = domainParts[domainParts.length - 1];

        if (tld.length < 2) {
            return { valid: false, message: "Top-level domain must be at least 2 characters long" };
        }

        if (!/^[a-zA-Z]+$/.test(tld)) {
            return { valid: false, message: "Top-level domain can only contain letters" };
        }

        return { valid: true, message: "Valid email" };
    };

    // For React onBlur handler - Recommended approach
    const handleEmailBlur = (e) => {
        const email = e.target.value.trim();

        if (email === "") {
            setUserDetails({
                ...userDetails,
                emailexist: false,
                emailvalidatemsg: ""
            });
            return;
        }

        // Use comprehensive validation
        const validation = validateEmailComprehensive(email);

        if (!validation.valid) {
            setUserDetails({
                ...userDetails,
                emailexist: true,
                emailvalidatemsg: validation.message
            });
        } else {
            setUserDetails({
                ...userDetails,
                emailexist: false,
                emailvalidatemsg: ""
            });
        }
    };

    if (props.currentStep !== 3) {
        return null;
    }

    return (
        <>
            <div className="booking-form-box">
                {
                    //check LoggedInData is null or not
                    LoggedInData == null ?
                        <div className="row">
                            <div className="col-md-12">
                                <div className="step-count">
                                    <div className="step-count-inner">
                                        <div className="Step-icon">
                                            <span><TbListCheck /></span>
                                        </div>
                                        <div className="step-count-inner-title">
                                            New Account Details
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                {usertype == 0 ?
                                    <Form >
                                        <div className="booking-acount-detail-form">
                                            <div className="row booking-30">
                                                <div className="col-md-12 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="validationCustom01">
                                                        <Form.Label>Preferred Email <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="email" value={userDetails.user_email || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({
                                                                    ...userDetails, user_email: e.target.value,
                                                                    emailexist: false
                                                                });
                                                                // if(e.target.value == ""){
                                                                //     setUserDetails({ ...userDetails, emailexist: false });
                                                                // }
                                                            }
                                                        }
                                                            onBlur={(e) => handleEmailBlur(e)}
                                                            placeholder="Enter email" className="booking-custom-input" />
                                                        {

                                                            userDetails.user_email == "" && signUprequest > 0 ?
                                                                <div className="form-error">Please enter a valid email address.</div>

                                                                : null
                                                        }
                                                        {

                                                            userDetails.emailexist == true ?
                                                                <div className="form-error">{userDetails.emailvalidatemsg}</div>
                                                                : null
                                                        }

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Preferred Password <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="password" placeholder="********" value={userDetails.password || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({ ...userDetails, password: e.target.value });
                                                            }
                                                        }
                                                            className="booking-custom-input" />
                                                        {

                                                            userDetails.password == "" && signUprequest > 0 ?
                                                                <div className="form-error">Please enter a password.</div>

                                                                : null
                                                        }
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Confirm Password <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="password" placeholder="********" value={confirmpassword || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({ ...userDetails, confirmpassword: e.target.value });
                                                                setConfirmpassword(e.target.value);
                                                            }
                                                        }
                                                            className="booking-custom-input" />

                                                        {

                                                            confirmpassword == "" && signUprequest > 0 ?
                                                                <div className="form-error">Please confirm your password.</div>

                                                                : null
                                                        }

                                                        {
                                                            confirmpassword != userDetails.password && confirmpassword != "" ?

                                                                <div className="form-error">Passwords do not match.</div>

                                                                : null
                                                        }

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>First Name <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="name" value={userDetails.first_name || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({ ...userDetails, first_name: e.target.value });
                                                            }
                                                        } placeholder="" className="booking-custom-input" />
                                                    </Form.Group>
                                                    {

                                                        userDetails.first_name == "" && signUprequest > 0 ?
                                                            <div className="form-error">Please enter your first name.</div>

                                                            : null
                                                    }
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Last Name <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="name" placeholder="" value={userDetails.last_name || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({ ...userDetails, last_name: e.target.value });
                                                            }
                                                        } className="booking-custom-input" />
                                                    </Form.Group>
                                                    {

                                                        userDetails.last_name == "" && signUprequest > 0 ?
                                                            <div className="form-error">Please enter your last name.</div>

                                                            : null
                                                    }
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Phone</Form.Label>
                                                        <Form.Control type="text" value={userDetails.phone || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({ ...userDetails, phone: e.target.value });
                                                            }
                                                        } placeholder="" className="booking-custom-input"
                                                        />
                                                    </Form.Group>
                                                    {/* {

                                                        userDetails.phone == "" && signUprequest > 0 ?
                                                            <div class="form-error">Please provide a valid phone.</div>

                                                            : null
                                                    } */}

                                                    {/* <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Phone <small style={{ color: "red", fontSize: "12px", fontWeight: "400" }}>(Without country code)</small></Form.Label>

                                                        <Form.Control
                                                            type="text"
                                                            maxLength={10}
                                                            value={userDetails.phone || ""}
                                                            onChange={(e) => {
                                                                const val = e.target.value.replace(/\D/g, ""); // Remove all non-digits
                                                                if (val.length <= 10) {
                                                                    setUserDetails({
                                                                        ...userDetails,
                                                                        phone: val,
                                                                        phoneValid: true,
                                                                        phoneError: ""
                                                                    });
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                const phoneValue = e.target.value.trim();

                                                                if (phoneValue === "") {
                                                                    setUserDetails({
                                                                        ...userDetails,
                                                                        phoneValid: false,
                                                                        phoneError: ""
                                                                    });
                                                                } else if (phoneValue.startsWith('0')) {
                                                                    setUserDetails({
                                                                        ...userDetails,
                                                                        phoneValid: false,
                                                                        phoneError: "Phone number cannot start with 0."
                                                                    });
                                                                } else if (phoneValue.length !== 10) {
                                                                    setUserDetails({
                                                                        ...userDetails,
                                                                        phoneValid: false,
                                                                        phoneError: "Phone number must be exactly 10 digits."
                                                                    });
                                                                } else if (!/^\d{10}$/.test(phoneValue)) {
                                                                    setUserDetails({
                                                                        ...userDetails,
                                                                        phoneValid: false,
                                                                        phoneError: "Phone number should contain only digits."
                                                                    });
                                                                } else {
                                                                    setUserDetails({
                                                                        ...userDetails,
                                                                        phoneValid: true,
                                                                        phoneError: ""
                                                                    });
                                                                }
                                                            }}
                                                            placeholder="Enter 10 digit phone number"
                                                            className="booking-custom-input"
                                                            onKeyPress={(e) => {
                                                                // Prevent negative sign and other non-numeric characters
                                                                if (e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
 
                                                        {userDetails.phone === "" && signUprequest > 0 ? (
                                                            <div className="form-error">Please provide a valid phone number.</div>
                                                        ) : null}

                                                        {userDetails.phoneError && userDetails.phone !== "" ? (
                                                            <div className="form-error">{userDetails.phoneError}</div>
                                                        ) : null}
                                                    </Form.Group> */}
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Zip Code <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="number" placeholder="" value={userDetails.zip || ""}
                                                            // onChange={
                                                            //     (e) => {
                                                            //         setUserDetails({ ...userDetails, zip: e.target.value });
                                                            //     }
                                                            // } 
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (value === "" || (Number(value) >= 0 && !value.includes('-'))) {
                                                                    setUserDetails({ ...userDetails, zip: value });
                                                                }
                                                            }}
                                                            className="booking-custom-input" />
                                                    </Form.Group>
                                                    {

                                                        userDetails.zip == "" && signUprequest > 0 ?
                                                            <div className="form-error">Please enter your zip code.</div>

                                                            : null
                                                    }
                                                    <div className="alert alert-danger" role="alert" style={{
                                                        display: error ? "block" : "none"
                                                    }}>
                                                        Sorry, we are not available in your area yet.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Street Address <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="" value={userDetails.address || ""} onChange={
                                                            (e) => {
                                                                setUserDetails({ ...userDetails, address: e.target.value });
                                                            }
                                                        } className="booking-custom-input" />
                                                        {

                                                            userDetails.address == "" && signUprequest > 0 ?
                                                                <div className="form-error">Please enter your street address.</div>

                                                                : null
                                                        }
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group
                                                        className="booking-custom-lable"
                                                        controlId="validationCustom010"
                                                    >
                                                        <Form.Label>State <span className="required-asterisk">*</span></Form.Label>
                                                        <Form.Select
                                                            aria-label="Default select example"
                                                            className="custom-select-box"
                                                            onChange={(e) => {
                                                                handleStateChange(e);
                                                            }}
                                                        >
                                                            <option>Select State</option>

                                                            {states.map((state) => (
                                                                <option value={state.stateCode}>{state.name}</option>
                                                            ))}

                                                        </Form.Select>
                                                        {

                                                            userDetails.state == "" && signUprequest > 0 ?
                                                                <div className="form-error">Please select a state.</div>

                                                                : null
                                                        }
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <Form.Group
                                                        className="booking-custom-lable"
                                                        controlId="validationCustom011"
                                                        onChange={(e) => {
                                                            handleCityChange(e);
                                                        }}
                                                    >
                                                        <Form.Label>City <span className="required-asterisk">*</span></Form.Label>
                                                        {/* <Form.Select
                                                            required
                                                            aria-label="Default select example"
                                                            className="custom-select-box"
                                                        >
                                                            <option>Select City</option>
                                                            {cities.map((city) => (
                                                                <option key={city} value={city}>
                                                                    {city}
                                                                </option>
                                                            ))}

                                                        </Form.Select> */}
                                                        <Form.Control type="text" placeholder="" value={userDetails.city || ""} onChange={(e) => { setUserDetails({ ...userDetails, city: e.target.value }); }} className="booking-custom-input" />
                                                    </Form.Group>
                                                    {

                                                        userDetails.city == "" && signUprequest > 0 ?
                                                            <div className="form-error">Please enter your city.</div>

                                                            : null
                                                    }
                                                </div>
                                                {/* <div className="col-md-12 mb-3">
                                                <div className="booking-custom-lable">
                                                    <button className="wizard-btn btn btn-primary d-flex float-right" style={{ "float": "right", }} onClick={UserSignUp}>SignUp</button>
                                                </div>
                                            </div> */}
                                                {/* <div className="col-md-12 mb-3">
                                                    <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                        <Form.Label>Appointment Notes</Form.Label>
                                                        <Form.Control type="text" placeholder="" value={appointmentNotes || ""} onChange={
                                                            (e) => {
                                                                setAppointmentNotes(e.target.value);
                                                            }
                                                        } className="booking-custom-input" />
                                                    </Form.Group>
                                                </div> */}
                                            </div>
                                            <div class="row">
                                                <label>
                                                    <input type="checkbox" name="sms_optin" required="" />
                                                    &nbsp;&nbsp; I agree to receive SMS updates from Green Frog Cleaning.
                                                </label>
                                            </div>
                                        </div>
                                    </Form>
                                    :
                                    <div className="booking-acount-detail-form">
                                        <div className="row booking-30">
                                            <div className="col-md-6 mb-3">
                                                <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                    <Form.Label>Preferred Email</Form.Label>
                                                    <Form.Control type="email" placeholder="Enter email" onChange={(e) => {
                                                        setExistingemail(e.target.value);

                                                    }} value={existingemail} className="booking-custom-input" />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                                    <Form.Label>Preferred Password</Form.Label>
                                                    <Form.Control type="password" placeholder="********" onChange={(e) => { setExistingpassword(e.target.value) }} value={existingpassword} className="booking-custom-input" />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <div className="booking-custom-lable">
                                                    <button className="wizard-btn btn btn-primary d-flex float-right" style={{ "float": "right", }} onClick={getUserDetails}>Login</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        :
                        <div className="row Service-details-box-inner-title">
                            <div className="col-md-12 mb-3">
                                <Form.Group className="booking-custom-lable" controlId="formBasicEmail">
                                    <Form.Label>Appointment Notes</Form.Label>
                                    <Form.Control type="text" placeholder="" value={appointmentNotes || ""} onChange={
                                        (e) => {
                                            setAppointmentNotes(e.target.value);
                                        }
                                    } className="booking-custom-input" />
                                </Form.Group>
                            </div>
                        </div>
                }
            </div>
            <NotificationContainer />
        </>

    );

};

export default Step3;
